import merge from 'deepmerge';

import common from './common';
import fr from './fr/customer.json';
import en from './en/customer.json';

const customer = {
  fr: fr.customer,
  en: en.customer,
};

export default merge(common, customer);
